"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorUtil = void 0;
class ErrorUtil {
    static serializeErrorForLogging(e) {
        if (e.response) {
            return JSON.stringify({
                message: e.message,
                responseData: e.response.data,
            });
        }
        else {
            return ErrorUtil.serializeError(e);
        }
    }
    static serializeError(e) {
        return JSON.stringify(e, Object.getOwnPropertyNames(e));
    }
}
exports.ErrorUtil = ErrorUtil;
//# sourceMappingURL=errorUtil.js.map